module.exports = __webpack_public_path__ + "img/message-dots-circle.ac00ee2d.svg";